import { render, staticRenderFns } from "./InstitutionWorkplaceCnpjInfoCard.vue?vue&type=template&id=a249fbe8&"
import script from "./InstitutionWorkplaceCnpjInfoCard.vue?vue&type=script&lang=js&"
export * from "./InstitutionWorkplaceCnpjInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports